import { useCallback } from 'react';
import { useDeleteQueueRequestMutation } from './useDeleteQueueRequestMutation';
import { showToast, TOAST_SUCCESS, FIVE_SECONDS } from 'lib/utils';
import { AskRequestTypes } from '../../constants';

const dissolveConfirmMessage = (count: number) =>
  `This group has ${count} item${count === 1 ? '' : 's'} inside. Dissolving will ungroup all items. Continue?`;

export const useDissolveGroup = (locationId: string) => {
  const deleteMutation = useDeleteQueueRequestMutation();

  const dissolveGroup = useCallback(
    async (requestId: string, requestType: string, requestCount?: number): Promise<boolean> => {
      if (!locationId || requestType !== AskRequestTypes.Group) return false;

      const count = requestCount ?? 0;
      if (count > 0) {
        const confirmed = window.confirm(dissolveConfirmMessage(count));
        if (!confirmed) return false;
      }

      await deleteMutation.mutateAsync({
        requestId,
        locationId,
      });
      showToast('Group dissolved', TOAST_SUCCESS, FIVE_SECONDS);
      return true;
    },
    [deleteMutation, locationId]
  );

  return { dissolveGroup };
};
